"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _stitches = require("../../stitches.config");

var StyledDivider = (0, _stitches.styled)('div', {
  display: 'flex',
  justifyContent: 'center',
  marginBottom: '20px',
  marginTop: '20px',
  position: 'relative',
  '&::before': {
    borderTop: '2px solid #dfdfdf',
    content: '""',
    left: '0',
    margin: '0 auto',
    position: 'absolute',
    right: '0',
    top: '50%',
    zIndex: '-1'
  }
});
var StyledText = (0, _stitches.styled)('span', {
  background: '$white',
  fontSize: '$xLarge',
  fontWeight: '$medium',
  paddingLeft: '20px',
  paddingRight: '20px'
});

var Divider = function Divider(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/_react.default.createElement(StyledDivider, null, /*#__PURE__*/_react.default.createElement(StyledText, null, text));
};

Divider.defaultProps = {
  text: undefined
};
var _default = Divider;
exports.default = _default;